import Panel from './panel.vue'
export { default as AppPanel } from './app-panel.vue'
export default Panel
